import React, { Component } from 'react';
import './LanguageSwitcher.css';
var counterpart = require('counterpart');
var Translate   = require('react-translate-component');

import EnLogo from './img/en.png';
import FrLogo from './img/fr.png';
import NlLogo from './img/nl.png';

var _t = Translate.translate;

counterpart.registerTranslations('en', require('../../languages/en'));
counterpart.registerTranslations('nl', require('../../languages/nl'));

class LanguageSwitcher extends Component {
  handleChange(e) {
    counterpart.setLocale(e);
  }

  render() {
    //var options = this.props.locales.map(function(locale) {
    //  var translationKey = 'watchdog.languages.' + locale;
    //
    //  return <Translate key={locale} value={locale} component="option" content={translationKey} />;
    //});
    return (
        <div>
          <button className="no_button_style" onClick={this.handleChange.bind(this, 'en')}>
            <img role="presentation" className="flagg_logo" src={EnLogo} />
          </button>
          <button className="no_button_style" onClick={this.handleChange.bind(this, 'nl')}>
            <img role="presentation" className="flagg_logo" src={NlLogo} />
          </button>
          <button className="no_button_style" onClick={this.handleChange.bind(this, 'fr')}>
            <img role="presentation" className="flagg_logo" src={FrLogo} />
          </button>
        </div>
    );
  }
}

export default LanguageSwitcher;


/** WEBPACK FOOTER **
 ** ./src/components/LanguageSwitcher/LanguageSwitcher.jsx
 **/